<template>
    <section id="mechanical_keyboard_sound" class="outer">
        <div class="inner">
            <header class="title">{{ title }}</header>
            <p>{{ content }}</p>
        </div>
    </section>
</template>

<script>
    export default {
        data () {
            return {
                title: 'Mechanical keyboard sound',
                content: 'After turning on the \'Enable Sound\' option, Tito Control will simulate mechanical keyboard sound when you click button. Feel more passionate when typing!'
            }
        }
    }
</script>

<style>
    #mechanical_keyboard_sound {
        padding-top: 40px;
        padding-bottom: 40px;
        background-color: #f8f8f8;
    }
</style>



// WEBPACK FOOTER //
// src/components/MechanicalKeyboardSound.vue